import unitConvertServiceGen from "./generated/unitConvertServiceGen";

class unitConvertService extends unitConvertServiceGen {
}

export default unitConvertService;